import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import * as a from 'actions/livefeedapi';
import { useInterval } from 'components/common/hooks'
import LivefeedTableList from './LivefeedTableList'
import TemplateTableList from './TemplateTableList'
import PropTypes from 'prop-types';

const SwitchTab = (props) => {
    const [isLivefeedTab, setIsLivefeedTab] = useState(true)
    const dispatch = useDispatch();
    dispatch(a.fetchLivefeed());
    dispatch(a.fetchTemplate());

    useInterval(() => {
        dispatch(a.fetchLivefeed());
        dispatch(a.fetchTemplate());
    }, 6000 * 10); // 1 min


    return (
        <React.Fragment>
            <div className="switch-tab">
                <span onClick={() => setIsLivefeedTab(true)}
                    className={`${isLivefeedTab ? 'tab_active' : ''} font--proLight`}>Livefeed</span>
                <span className="tab-divider"></span>
                <span onClick={() => setIsLivefeedTab(false)}
                    className={`${!isLivefeedTab ? 'tab_active' : ''} font--proLight`}>Template</span>
            </div>
            <div className="table-livefeed-wrapper">
                <div className={`white-box-container bg--white white-box-container_livefeed ${isLivefeedTab ? 'white-box-container_livefeed_active' : ''}`}>
                    <LivefeedTableList router={props.router} />
                </div>

                <div className={`white-box-container bg--white white-box-container_livefeed ${!isLivefeedTab ? 'white-box-container_livefeed_active' : ''}`}>
                    <TemplateTableList router={props.router} />
                </div>
            </div>
        </React.Fragment >
    )
}
SwitchTab.propTypes = {
    router: PropTypes.any.isRequired
}
export default SwitchTab


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/SwitchTab/index.jsx